
import React from "react";

import Async from "../../components/Async";

import { AttachMoney, PeopleRounded, Person } from "@material-ui/icons";

import FaciliterInvoices from "../../pages/admin/correspondents/invoices";

const AuthGuard = Async(() => import("../auth.guard"));

const Correspondent = Async(() => import('../../pages/admin/correspondents/correspondent'));
const CorrespondentDetails = Async(() => import('../../pages/admin/correspondents/correspondent.details'));
const FaciliterProfileView = Async(() => import("../../pages/profile/faciliter.profile"));


//external register
const ExternalCorrespondent = Async(() => import('../../pages/admin/correspondents/external-correspondent'));
const FaciliterContactVerification = Async(() => import('../../pages/faciliter/faciliter.contact.verification.page'));

const routes = {
    correspondents: {
        id: 'correspondents',
        name: 'Faciliters',
        path: '/faciliter',
        component: Correspondent,
        guard: AuthGuard,
        icon: <PeopleRounded />,
        roles: ['admin', 'operator'],
    },
    correspondentsDetails: {
        id: 'correspondentsDetails',
        name: 'Faciliters',
        path: '/faciliter/:id',
        component: CorrespondentDetails,
        disabledMenu: true,
        guard: AuthGuard,
        icon: <PeopleRounded />,
        roles: ['admin', 'operator'],
    },
    correspondentProfile: {
        id: 'correspondentProfile',
        name: 'Meu perfil',
        path: '/correspondent/profile',
        component: FaciliterProfileView,
        disabledMenu: false,
        icon: <Person />,
        guard: AuthGuard,
        roles: ['faciliter'],
    },
    faciliterInvoices: {
        id: 'faciliterInvoices',
        name: 'Faturamentos',
        path: '/invoices',
        component: FaciliterInvoices,
        icon: <AttachMoney />,
        roles: ['faciliter'],
    },
};


const externalRoutes = {
    externalContactVerification: {
        id: 'externalContactVerification',
        name: 'Verifique seus dados',
        path: '/faciliter/:uuid/verify-contacts',
        component: FaciliterContactVerification
    },
    externalCorrespondents: {
        id: 'externalCorrespondents',
        name: 'Faciliters',
        path: '/faciliter/:uuid/:isFaciliter/:faciliterType',
        component: ExternalCorrespondent
    },
}

const pages = Object.values(routes);

const externalPages = Object.values(externalRoutes);

export default {
    routes,
    externalRoutes,
    pages,
    externalPages
}